/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_NameInputs */

const en_jobs_name = /** @type {(inputs: Jobs_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const he_jobs_name = /** @type {(inputs: Jobs_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Jobs_NameInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_name = /** @type {((inputs?: Jobs_NameInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_NameInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_name(inputs)
	return he_jobs_name(inputs)
});